import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import CropOriginalIcon from '@material-ui/icons/CropOriginal';

import { useDropzone, FileRejection, DropEvent } from 'react-dropzone';
import useStyles from './ImageDropzone.styles';
import ImageDropzoneText from './ImageDropzoneText/ImageDropzoneText';
import useApi from '../../../utils/useApi';
import { endpoints } from '../../../utils/endpoints';
import { config } from '../../../constants/config';
import { SnackMessageContext } from '../../../contexts/snackMessage/SnackMessageContext';
import { useTranslation } from 'react-i18next';
import tPaths from '../../../utils/tPaths';

interface IProps {
  onChange: (url: string) => void;
}

const ImageDropzone: React.FC<IProps> = ({ onChange }) => {
  const styles = useStyles();
  const { post } = useApi(null);
  const { push } = useContext(SnackMessageContext);
  const { t } = useTranslation();

  const handleDrop = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
    const formData = new FormData();
    if (acceptedFiles.length) {
      formData.append('image', acceptedFiles[0], 'image.jpg');
      post({
        endpoint: endpoints.imageUpload,
        body: formData,
        onSuccess: (response) => {
          onChange(response.data.url);
        },
      });
    } else if (fileRejections.length) {
      if (fileRejections.length > 1) {
        push({ message: t(tPaths.dropzone.tooMany), severity: 'error' });
      } else if (fileRejections[0].file.size > config.maxFileSize) {
        push({ message: t(tPaths.dropzone.tooLarge), severity: 'error' });
      }
      push({ message: t(tPaths.dropzone.wrongFormat), severity: 'error' });
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    maxSize: config.maxFileSize,
    multiple: false,
    onDrop: handleDrop,
    accept: config.acceptedFiles,
  });

  return (
    <Box {...getRootProps()} className={styles.container}>
      <input {...getInputProps()} />
      <CropOriginalIcon className={styles.uploadImage} />
      <ImageDropzoneText isDragActive={isDragActive} />
    </Box>
  );
};

export default ImageDropzone;
